export default {
	// cardamom
	// 'raw-cardamom-sorting-journals': {
	// 	en: 'Cardamom Sorting Journals',
	// 	es: 'Diarios de Clasificación de Cardamomo'
	// },

	// 'cardamom-sorting-journals': {
	// 	en: 'After sorting journals',
	// 	es: 'Después de clasificar los diarios'
	// },

	// 'raw-cardamom-weight': {
	// 	en: 'Raw Cardamom Weight',
	// 	es: 'S/E'
	// },

	// 'raw-cardamom-item': {
	// 	en: 'Raw Cardamom Item',
	// 	es: 'Artículo de cardamomo crudo'
	// },

	// 'cardamom-root': {
	// 	en: 'Cardamom root',
	// 	es: 'Raíz de cardamomo'
	// },

	// 'cardamom-in-the-detachment': {
	// 	en: 'Cardamom under sorting',
	// 	es: 'Cardamomo en proceso de clasificación'
	// },

	// 'actual-amount-of-cardamom': {
	// 	en: 'Raw cardamom',
	// 	es: 'Cardamomo crudo'
	// },

	// 'cardamom-is-restricted-to-sorting': {
	// 	en: 'Under sorting cardamom',
	// 	es: 'Bajo clasificación de cardamomo'
	// },

	// 'raw-cardamom': {
	// 	en: 'Raw cardamom',
	// 	es: 'Cardamomo crudo'
	// }

	// pepper
	'raw-cardamom-sorting-journals': {
		en: 'Pepper Sorting Journals',
		es: 'Diarios de Clasificación de Pimienta'
	},

	'cardamom-sorting-journals': {
		en: 'After sorting journals',
		es: 'Después de clasificar los diarios'
	},

	'raw-cardamom-weight': {
		en: 'Raw Pepper Weight',
		es: 'S/E'
	},

	'raw-cardamom-item': {
		en: 'Raw Pepper Item',
		es: 'Artículo de pimienta cruda'
	},

	'cardamom-root': {
		en: 'Pepper root',
		es: 'Raíz de pimienta'
	},

	'cardamom-in-the-detachment': {
		en: 'Pepper under sorting',
		es: 'Pimienta en proceso de clasificación'
	},

	'actual-amount-of-cardamom': {
		en: 'Raw pepper',
		es: 'Pimienta cruda'
	},

	'cardamom-is-restricted-to-sorting': {
		en: 'Under sorting pepper',
		es: 'Bajo clasificación de pimienta'
	},

	'raw-cardamom': {
		en: 'Raw pepper',
		es: 'Pimienta cruda'
	}
}
